import * as React from "react";
import Form from "./../Form";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import FormDialog from "../../../../../../components/Dialog/FormDialog";
import { normalizeBoardHeaderData } from "../../hooks/boardHeaderUtils";

export function AddUserDialog(props) {
  const {
    onClose,
    selectedValue,
    open,
    boardName,
    users,
    isUpdateUser,
    currentUser,
    isColabrotar,
    handleAddColabrotor,
    setOpen,
    assigneeUserId,
    collaboratorOptions,
  } = props;

  const isMobile = useResponsive("down", "md");
  const board = normalizeBoardHeaderData(boardName);
  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <>
      <FormDialog
        handleClose={handleClose}
        open={open}
        fullWidth={true}
        className={"addUserModal"}
        title={
          isColabrotar
            ? `Add collaborator`
            : isUpdateUser
            ? `Update user to ${board?.board_name}`
            : `Add user to ${board?.board_name}`
        }
      >
        <Form
          onClose={handleClose}
          boardUsers={users}
          isMobile={isMobile}
          isColabrotar={isColabrotar}
          handleAddColabrotor={handleAddColabrotor}
          setOpen={setOpen}
          assigneeUserId={assigneeUserId}
          collaboratorOptions={collaboratorOptions}
          currentUser={currentUser && currentUser}
          isUpdateUser={isUpdateUser}
        />
      </FormDialog>
    </>
  );
}
